import ControlRunDetail from './ControlRunDetail'
export default ControlRunDetail
